import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ClientDto {
  clientNumber: string;
  clientName: string;
  street: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  clientStatus: string;
  industry: string;
  industryDescription: string;
  location: string;
  officeDescription: string;
  openDate: string;
}

export interface ClientSearchResponse {
  clients: ClientDto[];
  totalRecords: number;
  currentPage: number;
  totalPages: number;
}

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private http = inject(HttpClient);

  private readonly apiUrl = `${environment.apiUrl}/api/clients`;

  /**
   * Search clients by name/number, industry, etc.
   */
  searchClients(
    searchTerm?: string,
    contains?: string,
    industryCode?: string,
    pageSize?: number,
    pageNumber?: number,
  ): Observable<ClientSearchResponse> {
    let params = new HttpParams();

    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    if (contains) {
      params = params.set('contains', contains);
    }
    if (industryCode) {
      params = params.set('industryCode', industryCode);
    }
    if (pageSize != null) {
      params = params.set('pageSize', pageSize.toString());
    }
    if (pageNumber != null) {
      params = params.set('pageNumber', pageNumber.toString());
    }

    return this.http
      .get<ClientSearchResponse>(`${this.apiUrl}/search`, { params });
  }

  /**
   * Get a single client by client number
   */
  getClient(clientNumber: string): Observable<ClientDto> {
    return this.http.get<ClientDto>(`${this.apiUrl}/${clientNumber}`);
  }

  /**
   * Get multiple clients by list of client numbers
   */
  getClientsFromList(
    clientNumbers: string[],
    pageSize?: number,
    pageNumber?: number,
  ): Observable<ClientSearchResponse> {
    let params = new HttpParams();

    if (pageSize != null) {
      params = params.set('pageSize', pageSize.toString());
    }
    if (pageNumber != null) {
      params = params.set('pageNumber', pageNumber.toString());
    }

    return this.http
      .post<ClientSearchResponse>(`${this.apiUrl}/from-list`, clientNumbers, { params });
  }
}
